// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Xq-z","outfitFeedbackSection":"Yq-z"};